<template>
  <div>
    <section>
      <p-header />
      <slot />
      <p-footer />
    </section>
  </div>
</template>
